import apiClient from './apiClient';

/**
 * Service for Battery Pack specific views.
 */
const batteryPackService = {
    async getBatteryStats() {
        return await apiClient.get('/stats/battery');
    },

    async getBatteryDevices() {
        return await apiClient.get('/devices/category/battery-pack');
    },

    async getStats() {
        return await this.getBatteryStats();
    },

    async getDevices() {
        return await this.getBatteryDevices();
    }
};

export default batteryPackService;
